module.exports = __webpack_public_path__ + "static/media/evac-pod-action-alert.3af62488.svg";